import { create } from 'zustand';

export type Theme = 'light' | 'dark';

type ThemeState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggle: () => void;
};

/**
 * Tema de la app. NO se persiste en localStorage por consistencia con la
 * politica de "nada de datos sensibles persistidos por defecto"; vive solo
 * en memoria, al recargar vuelve al default.
 */
export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: 'light',
  setTheme: (theme) => {
    set({ theme });
    applyTheme(theme);
  },
  toggle: () => {
    const next: Theme = get().theme === 'light' ? 'dark' : 'light';
    set({ theme: next });
    applyTheme(next);
  },
}));

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}
